// frontend/packages/business-console/src/components/content/SaveStatusIndicator.jsx
//
// Shows the current save state: saving, saved, or unsaved changes.
// Persistent and always visible so the user always knows where they stand.

import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CircularProgress from "@mui/material/CircularProgress";

export default function SaveStatusIndicator({ saving, dirty, publishing, deleting }) {
  if (saving) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1 }}>
        <CircularProgress size={14} />
        <Typography variant="caption" sx={{ opacity: 0.75 }}>
          Saving your changes...
        </Typography>
      </Box>
    );
  }

  if (publishing) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1 }}>
        <CircularProgress size={14} />
        <Typography variant="caption" sx={{ opacity: 0.75 }}>
          Publishing to your live site...
        </Typography>
      </Box>
    );
  }

  if (deleting) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1 }}>
        <CircularProgress size={14} />
        <Typography variant="caption" sx={{ opacity: 0.75 }}>
          Deleting...
        </Typography>
      </Box>
    );
  }

  if (dirty) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1 }}>
        <WarningAmberIcon sx={{ fontSize: 16, color: "warning.main" }} />
        <Typography variant="caption" sx={{ color: "warning.main", fontWeight: 600 }}>
          You have unsaved changes
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1 }}>
      <CheckCircleOutlineIcon sx={{ fontSize: 16, color: "success.main" }} />
      <Typography variant="caption" sx={{ color: "success.main" }}>
        All changes saved
      </Typography>
    </Box>
  );
}
